<ng-container>

    <!-- Filter bar: pills + Total hours on same row -->
    <div class="vf-pt-filter-bar flex-shrink-0">
        <div class="d-flex align-items-center">
            <button *ngFor="let f of ([['thisWeek','This week'],['thisMonth','This month'],['lastMonth','Last month'],['allTime','All time']])"
                class="p-6-8-6-8 rounded-pill d-flex f-size-14 mr-2 h-32 cursor-pointer rounded-pill-filter text-nowrap hover:scale-105 hover:border-gray-400 hover:bg-gray-50/50"
                [ngClass]="{'active': activeFilter === f[0]}"
                (click)="setFilter(f[0])">
                <span>{{ f[1] }}&nbsp;<span class="opacity-75">({{ filterCounts[f[0]] }})</span></span>
            </button>
        </div>
        <div class="d-flex align-items-center gap-8">
            <div style="width:1px;height:20px;background:#d1d5db;flex-shrink:0;"></div>
            <div class="d-flex align-items-center gap-8">
                <span class="f-size-14 text-gray-500">Total hours</span>
                <span class="f-size-14 text-gray-400">&middot;</span>
                <span class="f-size-14 font-weight-medium text-gray-900">{{ totalTime }}</span>
            </div>
        </div>
    </div>

    <!-- Toolbar -->
    <div class="vf-pt-toolbar flex-shrink-0">
        <div class="d-flex align-items-center gap-8">
            <button type="button" class="btn bg-black text-white hover:bg-gray-800 rounded-sm d-flex align-items-center font-weight-medium h-36 px-12 border-0" (click)="openAddModal()">
                <lucide-icon name="plus" class="mr-1" [size]="16" [strokeWidth]="2"></lucide-icon> Add entry
            </button>
            <button type="button" class="d-flex border-gray-300 border rounded-8 bg-pure-white px-12 py-2 font-weight-medium h-36 text-gray-600 hover:bg-accent hover:text-accent-foreground"
                (click)="exportExcel()" title="Export to Excel" [disabled]="filteredEntries.length === 0">
                <lucide-icon name="file-spreadsheet" class="mr-1 text-gray-600" [size]="16" [strokeWidth]="2"></lucide-icon>
                <span class="text-gray-700 f-size-14">Excel export</span>
            </button>
            <div class="h-24 line-vertical bg-gray-300 mx-1"></div>
            <!-- Group / Collapse / Expand — connected button group matching task tab -->
            <div class="d-flex align-items-center border border-gray-300 rounded-sm vf-pt-group-ctrl">
                <div class="dropdown">
                    <button type="button" class="d-flex align-items-center gap-8 px-12 py-2 f-size-14 bg-transparent text-gray-600 hover:bg-gray-100 btn border-0 rounded-0 h-36"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <lucide-icon name="layers" [size]="16" [strokeWidth]="2"></lucide-icon>
                        <span>Group: {{ groupBy === 'none' ? 'None' : (groupBy === 'date' ? 'Date' : groupBy === 'person' ? 'Person' : 'Task') }}</span>
                        <lucide-icon name="chevron-down" [size]="12" [strokeWidth]="2"></lucide-icon>
                    </button>
                    <div class="dropdown-menu" style="min-width:140px;">
                        <a class="dropdown-item d-flex align-items-center justify-content-between" href="javascript:;" (click)="setGroupBy('date')">
                            <span class="text-none">Date</span>
                            <lucide-icon *ngIf="groupBy === 'date'" name="check" size="14" [strokeWidth]="2" class="no-fill text-blue-600"></lucide-icon>
                        </a>
                        <a class="dropdown-item d-flex align-items-center justify-content-between" href="javascript:;" (click)="setGroupBy('person')">
                            <span class="text-none">Person</span>
                            <lucide-icon *ngIf="groupBy === 'person'" name="check" size="14" [strokeWidth]="2" class="no-fill text-blue-600"></lucide-icon>
                        </a>
                        <a class="dropdown-item d-flex align-items-center justify-content-between" href="javascript:;" (click)="setGroupBy('task')">
                            <span class="text-none">Task</span>
                            <lucide-icon *ngIf="groupBy === 'task'" name="check" size="14" [strokeWidth]="2" class="no-fill text-blue-600"></lucide-icon>
                        </a>
                        <a class="dropdown-item d-flex align-items-center justify-content-between" href="javascript:;" (click)="setGroupBy('none')">
                            <span class="text-none">None</span>
                            <lucide-icon *ngIf="groupBy === 'none'" name="check" size="14" [strokeWidth]="2" class="no-fill text-blue-600"></lucide-icon>
                        </a>
                    </div>
                </div>
                <ng-container *ngIf="isGrouped">
                    <div class="vf-pt-group-sep"></div>
                    <button type="button" class="d-flex align-items-center gap-8 px-12 py-2 f-size-14 bg-transparent text-gray-600 hover:bg-gray-100 btn border-0 rounded-0 h-36"
                        (click)="collapseAll()" title="Collapse all">
                        <lucide-icon name="chevrons-up" [size]="16" [strokeWidth]="2"></lucide-icon>
                        Collapse
                    </button>
                    <div class="vf-pt-group-sep"></div>
                    <button type="button" class="d-flex align-items-center gap-8 px-12 py-2 f-size-14 bg-transparent text-gray-600 hover:bg-gray-100 btn border-0 rounded-0 h-36"
                        (click)="expandAll()" title="Expand all">
                        <lucide-icon name="chevrons-down" [size]="16" [strokeWidth]="2"></lucide-icon>
                        Expand
                    </button>
                </ng-container>
            </div>
        </div>
        <!-- Search -->
        <div class="position-relative">
            <lucide-icon name="search" size="14" class="text-gray-400 position-absolute" [strokeWidth]="2"
                style="top:50%;left:10px;transform:translateY(-50%);pointer-events:none;"></lucide-icon>
            <input type="text" class="vf-pt-search-input f-size-14"
                placeholder="Search time entries..."
                [ngModel]="searchText"
                (ngModelChange)="onSearch($event)">
        </div>
    </div>


    <!-- Empty state: no entries at all -->
    <div *ngIf="!isLoading && filteredEntries.length === 0 && allEntries.length === 0"
        class="d-flex flex-column align-items-center justify-content-center text-center px-24 flex-1" style="padding:60px 0;">
        <lucide-icon name="clock" size="36" class="text-gray-200 mb-15" [strokeWidth]="1.5"></lucide-icon>
        <p class="f-size-15 font-weight-medium text-gray-500 mb-8">No time logged yet</p>
        <p class="f-size-14 text-gray-400 mb-15">Team members can start timers or add entries from any task</p>
        <button class="btn h-36 px-16 f-size-14 font-weight-medium bg-gray-900 text-white rounded-6 border-0 d-flex align-items-center gap-8"
            (click)="openAddModal()">
            <lucide-icon name="plus" size="14" [strokeWidth]="2"></lucide-icon>
            Add entry
        </button>
    </div>

    <!-- Empty state: no results for current filter/search -->
    <div *ngIf="!isLoading && filteredEntries.length === 0 && allEntries.length > 0"
        class="d-flex flex-column align-items-center justify-content-center text-center px-24 flex-1" style="padding:60px 0;">
        <lucide-icon name="search" size="36" class="text-gray-200 mb-15" [strokeWidth]="1.5"></lucide-icon>
        <p class="f-size-15 font-weight-medium text-gray-500 mb-8">No matching entries</p>
        <p class="f-size-14 text-gray-400">Try adjusting your filters or search</p>
    </div>

    <!-- ag-grid -->
    <div *ngIf="isLoading || filteredEntries.length > 0" class="vf-pt-grid-wrap" style="width:100%; overflow:hidden;">
        <ag-grid-angular #ptGrid id="ptGrid"
            class="ag-theme-alpine custom-ag-theme no-border-grid"
            [style.height]="gridHeight" [style.width]="'100%'"
            [rowData]="filteredEntries"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            [groupDisplayType]="'groupRows'"
            [groupRowRendererParams]="groupRowRendererParams"
            [suppressAggFuncInHeader]="true"
            [groupDefaultExpanded]="-1"
            [animateRows]="true"
            [rowHeight]="rowHeight"
            [enableCellTextSelection]="true"
            [suppressContextMenu]="true"
            [preventDefaultOnContextMenu]="true"
            [quickFilterText]="searchText"
            (cellContextMenu)="onCellContextMenu($event)"
            (gridReady)="onGridReady($event)">
        </ag-grid-angular>
    </div>


</ng-container>

<!-- Row context menu — kept outside the *ngIf so #rowMenuRef always resolves and
     gets moved to <body> in ngAfterViewInit (escapes Bootstrap modal's transform). -->
<div #rowMenuRef class="vf-pt-row-context-menu" [class.show]="showRowMenu"
    [style.top.px]="rowMenuY" [style.left.px]="rowMenuX"
    (click)="$event.stopPropagation()">
    <a class="dropdown-item d-flex" href="javascript:;" (click)="onRowMenuEdit()">
        <lucide-icon name="pencil" [size]="16" [strokeWidth]="2" class="mr-1 no-fill text-gray-400"></lucide-icon>
        <span class="text-none">Edit</span>
    </a>
    <div role="separator" style="height: 1px; margin: 4px 0; background-color: #0000001a !important;"></div>
    <a class="dropdown-item d-flex hover:bg-red-50" href="javascript:;" (click)="onRowMenuDelete()">
        <lucide-icon name="trash-2" [size]="16" [strokeWidth]="2" class="mr-1 no-fill text-red-400"></lucide-icon>
        <span class="text-none text-red-600">Delete</span>
    </a>
</div>
<!-- Outside-click close is handled by document capture-phase listeners
     wired up in the component (see closeRowMenu / handleDocEvent). A
     fixed-position backdrop here would intercept right-clicks before
     ag-grid's cellContextMenu fires, breaking the "right-click another
     row to switch the menu" UX. -->

<!-- Add Entry Modal — wrapper is moved to <body> in ngAfterViewInit so the
     backdrop can cover the entire viewport (including the left main menu).
     The view-project slider's `.modal-dialog` has `transform: translate(0,0)`
     which creates a containing block for fixed-position descendants, so the
     modal must live outside the slider to escape that. -->
<div #addEntryModalRef>
<!-- Backdrop is provided by the slider's existing `.modal-backdrop` —
     `updateBodyForCenterModalShow()` strips `task-modal-body` from <body>
     so that backdrop becomes visible (covering the main menu too). Adding
     our own backdrop here would stack and dim twice. -->
<div *ngIf="showAddModal" class="modal fade show d-block center-modal trovve-sm-modal" tabindex="-1"
    style="overflow:hidden; z-index: 1065;">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 500px;margin: 1.75rem auto !important;width: calc(100% - 32px);">
        <div class="modal-content box-shadow-popup border-all" style="background: #fff !important; max-height: 500px; overflow: visible;">

            <!-- Header -->
            <div class="modal-header d-block px-0 pt-0 pb-3 border-top-0 border-left-0 border-right-0 border-b bg-transparent">
                <div class="row mx-0">
                    <div class="col px-0 align-self-center font-weight-medium text-gray-900 f-size-14 d-flex align-items-center">
                        <lucide-icon name="clock" class="mr-1 text-gray-500" size="16" [strokeWidth]="2"></lucide-icon>
                        {{ editingEntryId ? 'Edit time entry' : 'Add time entry' }}
                    </div>
                    <div class="col px-0 d-flex justify-content-end">
                        <button type="button" class="vf-modal-close-btn" (click)="closeEntryModal()" aria-label="Close">
                            <lucide-icon name="x" size="16" [strokeWidth]="2"></lucide-icon>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Body -->
            <div class="modal-body p-0 pt-3 mx-0 border-0 bg-pure-white" style="overflow: visible;">
                <div class="d-flex flex-column gap-16 w-100">

                    <!-- Date (Litepicker) -->
                    <div class="w-100">
                        <label class="f-size-14 text-gray-600 mb-8 d-block">Date</label>
                        <div class="vf-time-pill" (click)="openDatePicker()">
                            <lucide-icon name="calendar" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                            <input type="text" readonly autocomplete="off"
                                class="vf-time-pill-text-input flex-1 f-size-14"
                                [id]="getDatePickerElementId()"
                                placeholder="Select date">
                            <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                        </div>
                    </div>

                    <!-- Person (Bootstrap data-toggle dropdown, anchored to trigger's left edge) -->
                    <div class="w-100">
                        <label class="f-size-14 text-gray-600 mb-8 d-block">Person</label>
                        <div class="dropdown vf-pt-modal-person-drop position-relative w-100"
                            (shown.bs.dropdown)="onOpenPersonDropdown()">
                            <div class="vf-time-pill" data-toggle="dropdown" role="button" tabindex="0"
                                aria-haspopup="true" aria-expanded="false">
                                <ng-container *ngIf="!formUserId">
                                    <lucide-icon name="users" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                                    <span class="flex-1 text-left text-gray-400 f-size-14">Select person</span>
                                    <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                                </ng-container>
                                <ng-container *ngIf="formUserId">
                                    <span class="rounded-full bg-gray-200 text-gray-600 d-flex align-items-center justify-content-center flex-shrink-0 overflow-hidden"
                                        style="width: 20px; height: 20px; font-size: 10px;">
                                        <img *ngIf="formUserAvatarUrl" [src]="formUserAvatarUrl" [alt]="formUserName" class="w-100 h-100" style="object-fit: cover;">
                                        <span *ngIf="!formUserAvatarUrl">{{ getInitials(formUserName) }}</span>
                                    </span>
                                    <span class="flex-1 text-left text-truncate text-gray-800 f-size-14">{{ formUserName }}</span>
                                    <span class="d-inline-flex align-items-center justify-content-center text-gray-300 hover:text-gray-600 transition-colors cursor-pointer flex-shrink-0"
                                        (click)="clearPerson(); $event.stopPropagation();">
                                        <lucide-icon name="x" [size]="14" [strokeWidth]="2"></lucide-icon>
                                    </span>
                                </ng-container>
                            </div>
                            <div class="dropdown-menu rounded-8 p-0 w-100" (click)="$event.stopPropagation()" style="z-index: 1080;">
                                <div class="position-relative" style="border-bottom: 1px solid rgb(229, 231, 235);">
                                    <lucide-icon name="search" [size]="14" [strokeWidth]="2" class="text-gray-400 position-absolute"
                                        style="top: 50%; left: 12px; transform: translateY(-50%);"></lucide-icon>
                                    <input type="text" placeholder="Search person" autocomplete="off"
                                        class="form-control border-0 f-size-14 w-100 vf-dd-search-input"
                                        style="padding-left: 32px; height: 36px; background: #fff !important; border-radius: 0;"
                                        name="personSearchText"
                                        [value]="personSearchText"
                                        (input)="onPersonSearchInput($any($event.target).value)"
                                        (click)="$event.stopPropagation()">
                                </div>
                                <img *ngIf="isLoadingMembers" src="https://cdn.trovve.com/vfapp/images/loading-dots.gif"
                                    class="data-loading mx-auto d-block my-2" style="height: 14px;">
                                <div style="max-height: 240px; overflow-y: auto;" *ngIf="!isLoadingMembers">
                                    <button *ngFor="let member of visibleMembers" type="button"
                                        class="d-flex align-items-center gap-8 w-100 btn rounded-0 text-left transition-colors hover:bg-gray-50"
                                        style="padding: 8px 12px;"
                                        (click)="selectPerson(member)">
                                        <span class="rounded-full bg-gray-200 text-gray-600 d-flex align-items-center justify-content-center flex-shrink-0 overflow-hidden"
                                            style="width: 24px; height: 24px; font-size: 10px;">
                                            <img *ngIf="member.profilePictureUrl" [src]="member.profilePictureUrl" [alt]="member.memberName" class="w-100 h-100" style="object-fit: cover;">
                                            <span *ngIf="!member.profilePictureUrl">{{ getInitials(member.memberName) }}</span>
                                        </span>
                                        <span class="f-size-14 flex-1 text-truncate text-gray-900">{{ member.memberName }}</span>
                                    </button>
                                    <div *ngIf="visibleMembers.length === 0" class="text-center f-size-12 text-gray-400" style="padding: 16px 12px;">
                                        No users found
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Task (Bootstrap data-toggle dropdown — same pattern as Person) -->
                    <div class="w-100">
                        <label class="f-size-14 text-gray-600 mb-8 d-block">Task <span class="text-red-500">*</span></label>
                        <div class="dropdown vf-pt-modal-task-drop position-relative w-100"
                            (shown.bs.dropdown)="onOpenTaskDropdown()">
                            <div class="vf-time-pill" data-toggle="dropdown" role="button" tabindex="0"
                                aria-haspopup="true" aria-expanded="false">
                                <ng-container *ngIf="!formTaskId">
                                    <span class="flex-1 text-left text-gray-400 f-size-14">Select task</span>
                                    <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                                </ng-container>
                                <ng-container *ngIf="formTaskId">
                                    <span class="flex-1 text-left text-truncate text-gray-800 f-size-14">{{ formTaskName }}</span>
                                    <span class="d-inline-flex align-items-center justify-content-center text-gray-300 hover:text-gray-600 transition-colors cursor-pointer flex-shrink-0"
                                        (click)="clearTask(); $event.stopPropagation();">
                                        <lucide-icon name="x" [size]="14" [strokeWidth]="2"></lucide-icon>
                                    </span>
                                </ng-container>
                            </div>
                            <div class="dropdown-menu rounded-8 p-0 w-100" (click)="$event.stopPropagation()" style="z-index: 1080;">
                                <div class="position-relative" style="border-bottom: 1px solid rgb(229, 231, 235);">
                                    <lucide-icon name="search" [size]="14" [strokeWidth]="2" class="text-gray-400 position-absolute"
                                        style="top: 50%; left: 12px; transform: translateY(-50%);"></lucide-icon>
                                    <input type="text" placeholder="Search task" autocomplete="off"
                                        class="form-control border-0 f-size-14 w-100 vf-dd-search-input"
                                        style="padding-left: 32px; height: 36px; background: #fff !important; border-radius: 0;"
                                        name="taskSearchText"
                                        [value]="taskSearchText"
                                        (input)="onTaskSearchInput($any($event.target).value)"
                                        (click)="$event.stopPropagation()">
                                </div>
                                <div *ngIf="isSearchingTasks" class="text-center my-2">
                                    <div class="spinner-border spinner-border-sm text-gray-400" style="width:14px;height:14px;" role="status"></div>
                                </div>
                                <div style="max-height: 240px; overflow-y: auto;" *ngIf="!isSearchingTasks">
                                    <button *ngFor="let task of taskResults" type="button"
                                        class="d-flex flex-column align-items-start w-100 text-left bg-transparent border-0 border-bottom border-gray-100 gap-4 hover:bg-gray-50 transition-colors"
                                        style="padding: 8px 12px; cursor: pointer;"
                                        (click)="selectTask(task)">
                                        <span class="f-size-14 text-gray-800">{{ task.title }}</span>
                                        <span *ngIf="task.sectionName" class="f-size-12 text-gray-400">{{ task.sectionName }}</span>
                                    </button>
                                    <div *ngIf="taskResults.length === 0" class="text-center f-size-12 text-gray-400" style="padding: 16px 12px;">
                                        No tasks found
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Start time / End time (side by side) -->
                    <div class="w-100 d-flex gap-12">
                        <!-- Start time -->
                        <div class="flex-1 min-w-0">
                            <label class="f-size-14 text-gray-600 mb-8 d-block">Start time</label>
                            <div class="position-relative">
                                <div class="vf-time-pill position-relative">
                                    <span class="flex-1 text-left text-truncate" [class.text-gray-900]="formStartTime" [class.text-gray-400]="!formStartTime">
                                        {{ formStartTime ? formatTime(formStartTime) : 'Start' }}
                                    </span>
                                    <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                                    <input type="text" readonly class="vf-time-overlay-input"
                                        (focus)="onStartTimeFocus($event)" (blur)="hideStartTimeDropdown()">
                                </div>
                                <div *ngIf="showStartTimeDropdown" class="vf-time-options-dropdown">
                                    <ng-container *ngFor="let t of timeOptions; let i = index">
                                        <div *ngIf="getTimePeriodLabel(i)" class="vf-time-options-section">
                                            <div class="vf-time-options-section-line"></div>
                                            <span class="vf-time-options-section-label">{{ getTimePeriodLabel(i) }}</span>
                                            <div class="vf-time-options-section-line"></div>
                                        </div>
                                        <button type="button" class="vf-time-option" [class.active]="formStartTime === t"
                                            (mousedown)="selectStartTime(t)">{{ formatTime(t) }}</button>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <!-- End time -->
                        <div class="flex-1 min-w-0">
                            <label class="f-size-14 text-gray-600 mb-8 d-block">End time</label>
                            <div class="position-relative">
                                <div class="vf-time-pill position-relative">
                                    <span class="flex-1 text-left text-truncate" [class.text-gray-900]="formEndTime" [class.text-gray-400]="!formEndTime">
                                        {{ formEndTime ? formatTime(formEndTime) : 'End' }}
                                    </span>
                                    <lucide-icon name="chevron-down" [size]="14" class="text-gray-400 flex-shrink-0" [strokeWidth]="2"></lucide-icon>
                                    <input type="text" readonly class="vf-time-overlay-input"
                                        (focus)="onEndTimeFocus($event)" (blur)="hideEndTimeDropdown()">
                                </div>
                                <div *ngIf="showEndTimeDropdown" class="vf-time-options-dropdown">
                                    <ng-container *ngFor="let t of timeOptions; let i = index">
                                        <div *ngIf="getTimePeriodLabel(i)" class="vf-time-options-section">
                                            <div class="vf-time-options-section-line"></div>
                                            <span class="vf-time-options-section-label">{{ getTimePeriodLabel(i) }}</span>
                                            <div class="vf-time-options-section-line"></div>
                                        </div>
                                        <button type="button" class="vf-time-option" [class.active]="formEndTime === t"
                                            (mousedown)="selectEndTime(t)">{{ formatTime(t) }}</button>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Duration / validation / overlap warning -->
                    <p *ngIf="formDurationDisplay" class="f-size-12 text-gray-400 mb-0">Duration: {{ formDurationDisplay }}</p>
                    <p *ngIf="formValidationError" class="f-size-12 text-red-500 mb-0">{{ formValidationError }}</p>
                    <p *ngIf="!formValidationError && hasOverlap" class="f-size-12 text-amber-600 mb-0">This overlaps another time entry. Save anyway?</p>

                </div>
            </div>

            <!-- Footer -->
            <div class="vf-modal-footer d-flex p-0 pt-3 align-items-center border-top gap-8 justify-content-end">
                <button type="button" class="vf-modal-cancel-btn" (click)="closeEntryModal()">Cancel</button>
                <button type="button" [disabled]="!isFormValid || isSaving" (click)="saveEntry()"
                    class="btn btn-black h-36 px-12 py-10 font-weight-medium d-flex align-items-center gap-4">
                    {{ isSaving ? 'Saving...' : (hasOverlap ? 'Save anyway' : (editingEntryId ? 'Save changes' : 'Add entry')) }}
                </button>
            </div>

        </div>
    </div>
</div>
</div>
<!-- /#addEntryModalRef -->

